import Dexie, { Table } from 'dexie';
import { AppSettingsTable, BackboneTable, VisitUpSyncInfoTable } from './backbone-idb.types';




class BackBoneDB extends Dexie {
    backBoneVisits!: Table<BackboneTable, string>;
    visitUpSyncInfo!: Table<VisitUpSyncInfoTable, string>;
    appSettings!: Table<AppSettingsTable, string>;

    constructor() {
        super('backbone');
        this.version(4).stores({
            backBoneVisits: 'seq, userName, lastSyncDate',
            visitUpSyncInfo: 'seq, visitNo, userName, upSync',
            appSettings: 'key'
        });
    }
}

export const backboneDatabase = new BackBoneDB();
